import { CONTRACT, MEMBERSHIP, RESET } from '../types';

// values should be falsy
// use null over an empty array or object
// so that we can check them directly within the if conditions
// to find out if we have already fetched the data or not
export const state = () => ({
  contractState: null,
  membershipInfo: null,
});

export const getters = {
  [CONTRACT]({ contractState }) {
    return contractState;
  },

  [MEMBERSHIP]({ membershipInfo }) {
    return membershipInfo;
  },
};

/* eslint-disable no-param-reassign */
export const mutations = {
  [CONTRACT](stateObj, contractState) {
    stateObj.contractState = contractState;
  },

  [MEMBERSHIP](stateObj, membershipInfo) {
    stateObj.membershipInfo = membershipInfo;
  },

  [RESET](stateObj) {
    Object.assign(stateObj, state());
  },
};

export const actions = {
  [CONTRACT]({ commit }, contractState) {
    commit(CONTRACT, contractState);
  },

  [MEMBERSHIP]({ commit }, membershipInfo) {
    commit(MEMBERSHIP, { ...membershipInfo });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
